/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exp_Mk_Hero_BreadcrumbInputs */

const es_exp_mk_hero_breadcrumb = /** @type {(inputs: Exp_Mk_Hero_BreadcrumbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Experiencias`)
};

const gl_exp_mk_hero_breadcrumb = /** @type {(inputs: Exp_Mk_Hero_BreadcrumbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Experiencias`)
};

const en_exp_mk_hero_breadcrumb = /** @type {(inputs: Exp_Mk_Hero_BreadcrumbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Experiences`)
};

/**
* | output |
* | --- |
* | "Experiences" |
*
* @param {Exp_Mk_Hero_BreadcrumbInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const exp_mk_hero_breadcrumb = /** @type {((inputs?: Exp_Mk_Hero_BreadcrumbInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exp_Mk_Hero_BreadcrumbInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_exp_mk_hero_breadcrumb(inputs)
	if (locale === "en") return en_exp_mk_hero_breadcrumb(inputs)
	return es_exp_mk_hero_breadcrumb(inputs)
});